















































































































import { Component } from "vue-property-decorator";
import PluginComponent from "./PluginComponent";
import { EventBus, EVENTS } from "@/services/EventBus";
import LayerConfig from "@/models/map-context/LayerConfig";

@Component
export default class FeatureInfosPanelCustom extends PluginComponent {
  static ID = "FeatureInfosPanelCustom";
  static NAME = "FeatureInfosPanelCustom";

  isFeatureSelected = false;
  currentPage: string = "Infos";

  
  openIndex: number | null = null; 

  featureIndex=0;

  currentFeature: any = null;
  docs: any[] = [];
  layerOfFeature: LayerConfig | null = null;

  toggleAccordion(i: number) {
    this.openIndex = this.openIndex === i ? null : i;
  }

  openOnSelectedFeature(features:any):boolean{
    if(features.length>0 && (features[0].layerConfig.layername=='Dossiers')){
      return true
    }
    return false;
  }


  mounted() {
    EventBus.$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    if (selectedFeatures !== undefined) {
      this.onFeatureSelected(selectedFeatures);
    }
  }

  beforeDestroy() {
    EventBus.$off(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
  }

  onFeatureSelected(features: any) {
    this.featureIndex = 0;
    this.currentFeature = features[this.featureIndex];
    this.docs = this.currentFeature.getProperties().doc_joints;
    this.isFeatureSelected = true;
    this.getMapService().selectionService.addToSelection(this.currentFeature);

    // Récupération des documents (si présents dans les propriétés)
    this.layerOfFeature = this.currentFeature.layerConfig;
  }


  changePage(page: string) {
    this.currentPage = page;
  }

  getLabel(key: any) {
    if (this.layerOfFeature?.layerProperties) {
      const attr = this.layerOfFeature.layerProperties.find((d) => d.name === key);
      if (attr?.label) return attr.label;
    }
    return key;
  }

  isBoolean(key: any): boolean {
    if (this.layerOfFeature?.layerProperties) {
      const attr = this.layerOfFeature.layerProperties.find((d) => d.name === key);
      return attr?.type === "xsd:boolean";
    }
    return false;
  }

  isDisplay(key: any): boolean {
    if (this.layerOfFeature?.layerProperties) {
      const attr = this.layerOfFeature.layerProperties.find((d) => d.name === key);
      return attr?.display ?? true;
    }
    return true;
  }

  isUrl(value: any, key: any) {
    return (
      typeof value === "string" &&
      (value.startsWith("http://") ||
        value.startsWith("https://") ||
        key.startsWith("fiche_") ||
        ["acte_prop", "permis_cons", "plan_bornage", "video_drone"].includes(key))
    );
  }

  openInNewTab(url: string) {
    if (url) window.open(url, "_blank");
  }
}
